import React from "react";

export type HubDataContextValue = Record<string, never>;

const defaultValue: HubDataContextValue = {};

export const HubDataContext = React.createContext<HubDataContextValue>(defaultValue);

export const useHubData = () => React.useContext(HubDataContext);
